import RenderThumbnails from '@buildwise/pages/companyFiles/components/RenderThumbnails';
import { ArticleType, AttachmentType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import LightboxModal from 'components/common/modal/LightboxModal';
import { IMAGE_TYPES } from 'components/utils/constants';
import { useMemo, useState } from 'react';

const RenderAttachments = ({ attachments }: { attachments: AttachmentType[] }) => {
  const [lightboxOpen, setLightboxOpen] = useState<{
    open: boolean;
    fileName: string;
  }>({
    open: false,
    fileName: '',
  });
  const [thumbnails] = useMemo(() => {
    const mediaFiles: AttachmentType[] = [];
    const thumbnails: AttachmentType[] = [];

    attachments?.forEach((attachment) => {
      let fileType = `${attachment.fileType.toLowerCase().split('/')?.[1]}`;
      if (attachment.fileUploaded) {
        fileType = attachment.fileType.toLowerCase();
      }

      const isMediaFile = IMAGE_TYPES.includes(`image/${fileType}`);

      if (isMediaFile && !attachment?.isRemoved) {
        mediaFiles.push(attachment);
      }

      if (!attachment?.isRemoved) {
        thumbnails.push(attachment);
      }
    });

    return [thumbnails];
  }, [attachments]);
  return (
    <>
      <RenderThumbnails
        files={thumbnails}
        disabled
        setLightboxOpen={setLightboxOpen}
        isImage={(file: AttachmentType) => {
          let fileType = `${file.fileType.toLowerCase().split('/')?.[1]}`;
          if (file.fileUploaded) {
            fileType = file.fileType.toLowerCase();
          }
          return IMAGE_TYPES.includes(
            file.fileUploaded ? `image/${fileType}` : file.fileType.toLowerCase(),
          );
        }}
      />

      {lightboxOpen.open && (
        <LightboxModal<ArticleType>
          onClose={() => setLightboxOpen({ open: false, fileName: '' })}
          open={lightboxOpen.open}
          mode="view"
          mediaFiles={thumbnails}
          defaultOpenFileName={lightboxOpen.fileName}
        />
      )}
    </>
  );
};

export default RenderAttachments;
